// extracted by mini-css-extract-plugin
module.exports = {"root":"Sidebar_root__8HE0A","backdrop":"Sidebar_backdrop__NIM3h","sidebar-wrapper":"Sidebar_sidebar-wrapper__bwbCA","sidebar":"Sidebar_sidebar__C_RPJ"};